import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M10.525 2.72a1.38 1.38 0 0 1 1.262-.82 2.943 2.943 0 0 1 2.943 2.943V8.2c0 .193.157.35.35.35h3.328a3.45 3.45 0 0 1 3.41 3.975l-1.023 6.65a3.45 3.45 0 0 1-3.41 2.925H4.63a2.5 2.5 0 0 1-2.5-2.5v-6.65a2.5 2.5 0 0 1 2.5-2.5h2.232a.35.35 0 0 0 .32-.208l3.343-7.522ZM8.08 20.9h9.305a2.25 2.25 0 0 0 2.224-1.908l1.023-6.65a2.25 2.25 0 0 0-2.224-2.592H15.08a1.55 1.55 0 0 1-1.55-1.55V4.843c0-.963-.78-1.743-1.743-1.743a.18.18 0 0 0-.165.107L8.28 10.73c-.053.12-.12.23-.2.33v9.84Zm-1.2-9.25v9.25H4.63a1.3 1.3 0 0 1-1.3-1.3v-6.65a1.3 1.3 0 0 1 1.3-1.3h2.25Z"
      clip-rule="evenodd"
    />
  </svg>
`;
